import React from 'react';
import cl from './Footer.module.css';
import { NavLink } from 'react-router-dom';

const Footer = (props) => {
  return (
    <footer className={cl.app_footer}>
      <div className={cl.app_footer_main}>
        <div className={cl.app_footer_logolinks}>
          <div className={cl.middle_line_logo}>
            <h1>{props.shopName}</h1>
          </div>
          <h1>Pages</h1>
          <NavLink className={cl.footer_link} to="">
          Maison
          </NavLink>
          <NavLink className={cl.footer_link} to="/about">
          À propos de nous
          </NavLink>
          {/* <NavLink className = { cl.footer_link } to='/news'>News</NavLink> */}
          <NavLink className={cl.footer_link} to="/products">
          Des produits
          </NavLink>
          <NavLink className={cl.footer_link} to="/contacts">
            Contacts
          </NavLink>
        </div>
        <div className={cl.app_footer_links}>
          <h1>References</h1>
          <NavLink className={cl.footer_link} to="/policy">
          Politique de confidentialité
          </NavLink>
          <NavLink className={cl.footer_link} to="/terms">
          Conditions d'utilisation
          </NavLink>
          <NavLink className={cl.footer_link} to="/refund-policy">
          Politique de remboursement
          </NavLink>
          <NavLink className={cl.footer_link} to="/shipping-policy">
          Politique d'expédition
          </NavLink>
          <NavLink className={cl.footer_link} to="/cookies-policy ">
          Politique relative aux cookies
          </NavLink>
        </div>
        <div className={cl.app_footer_info}>
          <h2>NOUS ACCEPTONS</h2>
          <img
            src="https://cdn.icon-icons.com/icons2/1186/PNG/512/1490135017-visa_82256.png"
            alt="Visa"
          />
          <img
            src="https://www.iconarchive.com/download/i76278/designbolts/credit-card-payment/Master-Card.ico"
            alt="Master Card"
          />
        </div>
        <div className={cl.app_footer_info}>
          <h2>NOUS VOULONS ENTENDRE VOTRE VOIX</h2>
          <p>
          Notre société a été créée en 2012 avec seulement 3 employés. Au dessus de
             années, perfectturn compte plus de 500 000 clients satisfaits. C'est
             important que nous continuions à offrir des produits incroyables à notre meilleur
             clients, dont chacun comprend un service client par téléphone, SMS
             et e-mail. Nous avons hâte de grandir avec vous!
          </p>
        </div>
      </div>
      <div className={cl.app_footer_bottom_line}>
        <p>Droits d'auteur 2023 {props.shopName}</p>
      </div>
    </footer>
  );
};

export default Footer;
